<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="快捷入口：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="内容描述：">
              <Input type="textarea" :maxlength="100" show-word-limit :autosize="{minRows: 5,maxRows: 5}" v-model="formInline.description" />
            </FormItem>
            <FormItem label="按钮名称：">
              <Input v-model="formInline.linkName" />
            </FormItem>
            <FormItem label="链接地址：">
              <Input v-model="formInline.link" />
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :max="9999" :min="0" v-model="formInline.showIndex" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "entrance-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelTitle:{
      type:String,
    },
    options:{
      type:Object
    },
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formInline: {
        name: "",
        description: "",
        linkName: "",
        link: "",
        showIndex: 0,
      },
      ruleInline: {
        name: [{ required:true, message: "必填选项", trigger: "blur" }]
      },
      editId: "",
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val){
      if(val.msg){
        this.formInline.name = val.msg.name;
        this.formInline.description = val.msg.description;
        this.formInline.linkName = val.msg.linkName;
        this.formInline.link = val.msg.link;
        this.formInline.showIndex = val.msg.showIndex;
        this.editId = val.msg.id;
      }
    }
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addEntrance: "hostCommonModule/addEntrance",
      editEntrance: "hostCommonModule/editEntrance",
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;

      // 编辑模式
      if(this.options.model){ 
        this.editPro(form);
      } else { // 新增模式
        this.addPro(form);
      }
    },
    async addPro(form){
      let body = {
        Name: form.name,
        Description: form.description,
        LinkName: form.linkName,
        Link: form.link,
        ShowIndex: form.showIndex,
      }
      let bool = await this.addEntrance(body);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("添加成功！");
        this.cancel();
        this.$emit('finish');
      } else {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      }
    },
    async editPro(form){
      let body = {
        Id:this.editId,
        SetValues:{
          Name: form.name,
          Description: form.description,
          LinkName: form.linkName,
          Link: form.link,
          ShowIndex: form.showIndex,
        }
      }
      let bool = await this.editEntrance(body);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("修改成功！");
        this.cancel();
        this.$emit('finish');
      } else {
        this.loading = false;
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        name: "",
        description: "",
        linkName: "",
        link: "",
        showIndex: 0,
      }
      this.editId = "";
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
}
</style>

